export const getDashboardAlertColor = (type) => {
    switch (type) {
        case 'danger':
            return '#f46a6a'
        case 'warning':
            return '#f1b44c'
        case 'success':
            return '#34c38f'
        default:
            return '#50a5f1'
    }
}

export const getHealthStatusMeta = (status) => {
    switch (status) {
        case 'ok':
            return {
                label: 'Vigente',
                color: 'success'
            }
        case 'warning':
            return {
                label: 'Por vencer',
                color: 'warning'
            }
        case 'expired':
            return {
                label: 'Expirado',
                color: 'danger'
            }
        default:
            return {
                label: 'Pendiente',
                color: 'secondary'
            }
    }
}

export const buildFlujoSeries = (flujo = {}) => {
    return [
        {
            name: 'Facturado',
            data: flujo?.series?.facturado || []
        },
        {
            name: 'Cobrado',
            data: flujo?.series?.cobrado || []
        }
    ]
}

export const calcTasaCobro = (facturado, cobrado) => {
    if (!facturado || facturado === 0) return '0%'
    const tasa = (cobrado / facturado) * 100
    return `${tasa.toFixed(1)}%`
}

export const getAlertBorderColor = (type) => {
    switch (type) {
        case 'warning': return '#EF9F27'
        case 'danger': return '#E24B4A'
        case 'info': return '#378ADD'
        default: return '#378ADD'
    }
}
